import moment from "moment";
import QrCodeHelper from "qrcode-svg";

import i18n from "../../../plugins/i18n";
import { getImage, getLocalisedValue } from "@/app/core-module/util/coreHelper";

import certificateHtmlTemplate from "@/app/course-module/assets/templates/certificate_template.htm";

import { EnvSubscriberHelper } from "@/app/env_subscriber_helper";

// used in EMPLOYEE
export const getTrainingCertificateHtmlTemplate = ({
  trainingCertificate,
  subscriberInfo,
  height,
}) => {
  const primaryColor = [107, 133, 166];
  const secondaryColor = [25, 26, 24];
  const leftGridColor = [208, 209, 203];
  const accentColor = [178, 69, 66];

  let htmlTemplate = certificateHtmlTemplate;
  htmlTemplate = htmlTemplate.replace(
    /certificate-template-style/g,
    `certificate-template-style-${Date.now()}`
  );

  //primaryColor
  //secondaryColor
  //leftGridColor
  //certificateBackground
  //subscriberLogo
  //employeeQrCodeHidden
  //employeeQrCode
  //certificateHeading
  //thisIsToCertify
  //employeeName
  //employeeCompanyName
  //employeeCompanyCode //KDC#: 6812
  //inRecognition
  //trainingTitle
  //trainingCompletedDate
  //trainingExpiryDate
  //certificateNumber
  //managingDirectorTitle
  //trainerTitle
  //managingDirectorName
  //trainerName

  htmlTemplate = htmlTemplate.replace(
    /--primaryColor: #000000/g,
    `--primaryColor: rgba(${primaryColor[0]}, ${primaryColor[1]}, ${primaryColor[2]}, 1)`
  );

  htmlTemplate = htmlTemplate.replace(
    /--secondaryColor: #000000/g,
    `--secondaryColor: rgba(${secondaryColor[0]}, ${secondaryColor[1]}, ${secondaryColor[2]}, 1)`
  );

  //region left section background color
  htmlTemplate = htmlTemplate.replace(
    /--leftGridColor: #000000/g,
    `--leftGridColor: rgba(${leftGridColor[0]}, ${leftGridColor[1]}, ${leftGridColor[2]}, 1)`
  );
  //endregion

  //region subscriber background
  /*const { certificateBackground } =
    EnvSubscriberHelper.getEnvCertificateRelatedValues();

  if (certificateBackground) {
    htmlTemplate = htmlTemplate.replace(
      /{{certificateBackground}}/g,
      certificateBackground
    );
  }*/
  //endregion

  //region subscriber logo
  const subscriberLogo = getImage(subscriberInfo?.user?.avatar, {
    params: `?r=${Math.random()}`,
  });

  if (subscriberLogo) {
    htmlTemplate = htmlTemplate.replace(
      /--subscriberLogoHidden: hidden/g,
      "--subscriberLogoHidden: visible"
    );
    htmlTemplate = htmlTemplate.replace(/{{subscriberLogo}}/g, subscriberLogo);
  } else {
    htmlTemplate = htmlTemplate.replace(/{{subscriberLogo}}/g, "");
  }

  //endregion

  //region partner org logos
  const { orgLogos } = EnvSubscriberHelper.getEnvCertificateRelatedValues();
  if (orgLogos.length) {
    htmlTemplate = htmlTemplate.replace(
      /--subscriberOrgHidden: hidden/g,
      "--subscriberOrgHidden: visible"
    );

    htmlTemplate = htmlTemplate.replace(/{{subscriberOrg1}}/g, orgLogos[0]);
    htmlTemplate = htmlTemplate.replace(/{{subscriberOrg2}}/g, orgLogos[1]);
    htmlTemplate = htmlTemplate.replace(/{{subscriberOrg4}}/g, orgLogos[2]);
    htmlTemplate = htmlTemplate.replace(/{{subscriberOrg5}}/g, orgLogos[3]);
    htmlTemplate = htmlTemplate.replace(/{{subscriberOrg6}}/g, orgLogos[4]);
    htmlTemplate = htmlTemplate.replace(/{{subscriberOrg7}}/g, orgLogos[5]);
    htmlTemplate = htmlTemplate.replace(/{{subscriberOrg8}}/g, orgLogos[6]);
    htmlTemplate = htmlTemplate.replace(/{{subscriberOrg10}}/g, orgLogos[7]);
  }
  //endregion

  //region employeeAvatar
  const employeeAvatar =
    getImage(trainingCertificate?.employee?.user?.avatar, {
      params: `?r=${Math.random()}`,
    }) ?? "";

  if (employeeAvatar?.length) {
    htmlTemplate = htmlTemplate.replace(
      /--employeeAvatarHidden: hidden/g,
      "--employeeAvatarHidden: visible"
    );
    htmlTemplate = htmlTemplate.replace(/{{employeeAvatar}}/g, employeeAvatar);
  } else {
    // htmlTemplate = htmlTemplate.replace(/{{employeeAvatarHidden}}/g, "hidden");
    htmlTemplate = htmlTemplate.replace(/{{employeeAvatar}}/g, "");
  }
  //endregion

  //region qrcode
  const domainUrl = `${process.env.VUE_APP_EMPLOYEE_URL}/${
    i18n.locale || "en"
  }`;
  const shareUrl = `${domainUrl}/public-profile/${trainingCertificate.employee?.user?._id}`;

  const qrCodeSvg = new QrCodeHelper({
    content: shareUrl,
    padding: 0,
    width: height / 10,
    height: height / 10,
    color: `rgba(${secondaryColor[0]}, ${secondaryColor[1]}, ${secondaryColor[2]}, 1)`,
    background: "rgba(89, 40, 229, 0)",
    container: "svg",
  }).svg();

  if (qrCodeSvg) {
    htmlTemplate = htmlTemplate.replace(/{{employeeQrCode}}/g, qrCodeSvg);
  } else {
    htmlTemplate = htmlTemplate.replace(/{{employeeQrCode}}/g, "");
  }
  //endregion

  //region certificateHeading, thisIsToCertify
  htmlTemplate = htmlTemplate.replace(
    /{{certificateHeading}}/g,
    "Certificate of Completion"
  );

  htmlTemplate = htmlTemplate.replace(
    /{{thisIsToCertify}}/g,
    "This is to certify that"
  );
  //endregion

  //region employeeName
  const employeeName = trainingCertificate.employeeName ?? "employeeName";
  htmlTemplate = htmlTemplate.replace(/{{employeeName}}/g, employeeName);
  //endregion

  //region employeeDesignation
  const employeeDesignation = (
    trainingCertificate.employeeDesignation ??
    trainingCertificate.employee?.designation ??
    ""
  ).trim();

  htmlTemplate = htmlTemplate.replace(
    /{{employeeDesignation}}/g,
    employeeDesignation
  );
  //endregion

  //region employeeCompanyName
  const employeeCompanyName = getLocalisedValue(
    trainingCertificate?.organizationName,
    { preferredLocale: "en" }
  );

  htmlTemplate = htmlTemplate.replace(
    /{{employeeCompanyName}}/g,
    employeeCompanyName
  );
  //endregion

  //region TODO: employeeUID
  const employeeUID =
    trainingCertificate.employeeCivilIdOrPassport ??
    trainingCertificate.employeeNo ??
    "";
  htmlTemplate = htmlTemplate.replace(/{{employeeCompanyCode}}/g, employeeUID);
  //endregion

  //region inRecognition
  htmlTemplate = htmlTemplate.replace(
    /{{inRecognition}}/g,
    "“In recognition of having satisfactorily completed the training course titled “:"
  );
  //endregion

  //region trainingTitle
  const trainingTitle = getLocalisedValue(trainingCertificate?.trainingTitle, {
    preferredLocale: "en",
    uppercase: true,
    emptyNotation: "&nbsp;",
  });

  htmlTemplate = htmlTemplate.replace(/{{trainingTitle}}/g, trainingTitle);
  //endregion

  //region trainingDescription
  const trainingDescription = getLocalisedValue(
    trainingCertificate?.trainingDescription,
    {
      preferredLocale: "en",
      emptyNotation: "&nbsp;",
    }
  );

  htmlTemplate = htmlTemplate.replace(
    /{{trainingDescription}}/g,
    trainingDescription
  );
  //endregion

  //region trainingCompletedDate
  const trainingCompletedDate = trainingCertificate.completedAt
    ? moment(parseInt(trainingCertificate.completedAt)).format("DD MMM YYYY")
    : "";

  htmlTemplate = htmlTemplate.replace(
    /{{trainingCompletedDate}}/g,
    `Course Date: ${trainingCompletedDate}`
  );
  //endregion

  //region trainingExpiryDate
  const trainingExpiryDate = trainingCertificate.expiresAt
    ? moment(parseInt(trainingCertificate.expiresAt)).format("DD MMM YYYY")
    : "";

  htmlTemplate = htmlTemplate.replace(
    /{{trainingExpiryDate}}/g,
    `Valid Until: ${trainingExpiryDate}`
  );
  //endregion

  //region certificateNumber
  const certificateNumber = trainingCertificate.certificateNumber ?? "";

  htmlTemplate = htmlTemplate.replace(
    /{{certificateNumber}}/g,
    `Certificate No.: ${certificateNumber}`
  );
  //endregion

  //region managingDirectorTitle, trainerTitle
  htmlTemplate = htmlTemplate.replace(
    /{{managingDirectorTitle}}/g,
    "Managing Director"
  );

  htmlTemplate = htmlTemplate.replace(/{{trainerTitle}}/g, "Instructor");
  //endregion

  //region managingDirectorName & sign
  const { managingDirectorName, mdSignature } =
    EnvSubscriberHelper.getEnvCertificateRelatedValues(trainingCertificate);

  htmlTemplate = htmlTemplate.replace(
    /{{managingDirectorName}}/g,
    managingDirectorName
  );

  if (mdSignature) {
    htmlTemplate = htmlTemplate.replace(
      /--mdSignatureHidden: hidden/g,
      "--mdSignatureHidden: visible"
    );

    htmlTemplate = htmlTemplate.replace(/{{mdSignature}}/g, mdSignature);
  }
  //endregion

  //region trainerName & sign
  const { trainerName, trainerSignature } =
    EnvSubscriberHelper.getEnvCertificateRelatedValues(trainingCertificate);

  htmlTemplate = htmlTemplate.replace(/{{trainerName}}/g, trainerName);

  if (trainerSignature) {
    htmlTemplate = htmlTemplate.replace(
      /--trainerSignatureHidden: hidden/g,
      "--trainerSignatureHidden: visible"
    );

    htmlTemplate = htmlTemplate.replace(
      /{{trainerSignature}}/g,
      trainerSignature
    );
  }
  //endregion

  //region subscriber other info
  const { subscriberContact, subscriberApprovalRef } =
    EnvSubscriberHelper.getEnvCertificateRelatedValues();

  htmlTemplate = htmlTemplate.replace(
    /{{subscriberApprovalRef}}/g,
    subscriberApprovalRef
  );

  htmlTemplate = htmlTemplate.replace(
    /{{subscriberContact}}/g,
    subscriberContact
  );
  //endregion

  //region subscriber seal
  const { certificateSeal } =
    EnvSubscriberHelper.getEnvCertificateRelatedValues();
  if (certificateSeal) {
    htmlTemplate = htmlTemplate.replace(
      /--subscriberSealHidden: hidden/g,
      "--subscriberSealHidden: visible"
    );

    htmlTemplate = htmlTemplate.replace(/{{subscriberSeal}}/g, certificateSeal);
  } else {
    htmlTemplate = htmlTemplate.replace(/{{subscriberSeal}}/g, "");
  }
  //endregion

  //region card size
  htmlTemplate = htmlTemplate.replace(/height="600"/g, `height="${height}"`);

  htmlTemplate = htmlTemplate.replace(/calc\(600px/g, `calc(${height}px`);
  //endregion

  return htmlTemplate;
};
